import Vue from 'vue';
import Vuex from 'vuex';

import http from './http';
import canvas from './canvas';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    role: null,
    picture: null,
    currentUserName: null,
    intents: null,
    anchorTypes: [],
    breadcrumbs: null,
    colors: [],
    currentProject: null
  },
  mutations: {
    setAnchorTypes(state, anchorTypes) {
      state.anchorTypes = anchorTypes;
    },
    setToken(state, value) {
      state.token = value;
    },
    setRole(state, value) {
      state.role = value;
    },
    setPicture(state, value) {
      state.picture = value;
    },
    setCurrentUserName(state, value) {
      state.currentUserName = value;
    },
    setIntents(state, value) {
      state.intents = value;
    },
    setBreadcrumbs(state, value) {
      state.breadcrumbs = value;
    },
    setColors(state, value) {
      state.colors = value;
    },
    setCurrentProject(state, value) {
      state.currentProject = value;
    }
  },
  actions: {
    logout({ commit }) {
      commit('setToken', null);
      Vue.$storage.remove('token');
    }
  },
  modules: {
    http,
    canvas
  }
});
